import PropTypes from 'prop-types'
import React from 'react'

import { Tooltip } from 'react-wot-bootstrap'

import {
    SLOT_TOOLTIP_MESSAGE,
    SLOT_TOOLTIP_MESSAGE_NO_PERMISSION,
} from './constants.jsx'

import styles from './SlotTooltip.scss'

const SlotTooltip = (props) => {
    const message = props.hasPermission ? SLOT_TOOLTIP_MESSAGE : SLOT_TOOLTIP_MESSAGE_NO_PERMISSION
    return (
        <Tooltip id={`slot_${props.slotId}`}>
            <div className={styles.content}>
                <p className={styles.message}>{
                    (props.showConstructMessage ? message : null)
                }</p>
            </div>
        </Tooltip>
    )
}

SlotTooltip.defaultProps = {
    showConstructMessage: true,
}

SlotTooltip.propTypes = {
    slotId: PropTypes.number.isRequired,
    showConstructMessage: PropTypes.bool,
    hasPermission: PropTypes.bool.isRequired,
}

export default SlotTooltip



// WEBPACK FOOTER //
// ./containers/Stronghold/components/SlotTooltip/SlotTooltip.jsx